import React from "react";

import { IGeneralData } from "@np/np_webcomponentlib";

import { optionEnum } from "../../shared/entityOperations/EntityFormTypes";

import { Column, ListFields } from "@np/np_webcomponentlib";

import { EntityFormProps } from "../../shared/entityOperations/EntityFormTypes";

import { ColumnWithCopyToClipboard } from "../../shared/entityOperations/EntityOperationsCustomFC";

enum TypeOperationEnum {
  payIn,
  payOut,
}

enum TypePaymentMethodEnum {
  toCard,
  sbp,
  toAccount,
  transgran,
  transgranSBP,
  nspk,
  ecom = "ecom",
  mobile = "mobile",
  alfa_alfa = "alfa_alfa",
  sber_sber = "sber_sber",
  ozon_ozon = "ozon_ozon",
  tbank_tbank = "tbank_tbank",
  vtb_vtb = "vtb_vtb",
  gazprom_gazprom = "gazprom_gazprom",
  psb_psb = "psb_psb",
  azn_c2c = "azn_c2c",
  azn_quasi = "azn_quasi",
}

export interface optionEnumTypeOperationEnum {
  value?: TypeOperationEnum;
  label: string;
  isDisabled?: any;
}

export interface optionEnumTypePaymentMethodEnum {
  value?: TypePaymentMethodEnum;
  label: string;
  isDisabled?: any;
}

export const optionsEnumTypeOperationEnum: optionEnumTypeOperationEnum[] = [
  { value: undefined, label: "Choose one", isDisabled: "true" },
  { value: TypeOperationEnum.payIn, label: "Прием" },
  { value: TypeOperationEnum.payOut, label: "Выплаты" },
];

export const optionsEnumTypePaymentMethodEnum: optionEnumTypePaymentMethodEnum[] = [
  { value: undefined, label: "Choose one", isDisabled: "true" },
  { value: TypePaymentMethodEnum.toCard, label: "На карту" },
  { value: TypePaymentMethodEnum.sbp, label: "СБП" },
  { value: TypePaymentMethodEnum.toAccount, label: "На счет" },
  { value: TypePaymentMethodEnum.transgran, label: "Трансгран" },
  { value: TypePaymentMethodEnum.transgranSBP, label: "Трансгран СБП" },
  { value: TypePaymentMethodEnum.nspk, label: "НСПК" },
  { value: TypePaymentMethodEnum.ecom, label: "ECOM" },
  { value: TypePaymentMethodEnum.mobile, label: "Мобильный" },

  { value: TypePaymentMethodEnum.alfa_alfa, label: "alfa_alfa" },
  { value: TypePaymentMethodEnum.sber_sber, label: "sber_sber" },
  { value: TypePaymentMethodEnum.ozon_ozon, label: "ozon_ozon" },
  { value: TypePaymentMethodEnum.tbank_tbank, label: "tbank_tbank" },
  { value: TypePaymentMethodEnum.vtb_vtb, label: "vtb_vtb" },
  { value: TypePaymentMethodEnum.gazprom_gazprom, label: "gazprom_gazprom" },
  { value: TypePaymentMethodEnum.psb_psb, label: "psb_psb" },
  { value: TypePaymentMethodEnum.azn_c2c, label: "AZN C2C" },
  { value: TypePaymentMethodEnum.azn_quasi, label: "AZN Quasi" },
];

export interface EntityType {
  [key: string]: string | number | Date | boolean | null | undefined; // Допускаем, что значения могут быть строками или числами

  idrfRate: string;
  typeOperation?: TypeOperationEnum;
  paymentMethod?: TypePaymentMethodEnum;
  comissionPercent: number;
  minimumComission: number;
  minAmountPayment: number;
  maxAmountPayment: number;
  comments?: string;
  bank?: string;
}

export interface DataEntityType extends IGeneralData, EntityType {}

export interface DataEntityTypeViewModel {}

//Расширенные данные для передачи сущности с предустановленными значениями для создания
export interface EntityFormPropsWithType extends EntityFormProps {
  initEntityProps: EntityType | undefined;
}

// export const getEntityBylistVals = (listFields: ListFields[], entity: EntityType): EntityType => {
//   // Создаем новый объект на основе initEntity, чтобы не изменять оригинал
//   const updatedEntity: EntityType = { ...entity };

//   listFields.forEach(field => {
//     // Проверяем, существует ли такое поле в initEntity
//     if (field.fieldName in updatedEntity) {
//       // Устанавливаем первое значение из listVal, если оно существует
//       const valueToSet = field.listVal.length > 0 ? field.listVal[0] : '';
//       updatedEntity[field.fieldName] = valueToSet;
//     }
//   });

//   return updatedEntity;
// }

export const initEntity: EntityType = {
  idrfRate: "",
  comissionPercent: 0,
  minimumComission: 0,
  minAmountPayment: 0,
  maxAmountPayment: 0,
};

export const columnsForChoose: Column[] = [
  {
    title: "",
    listFields: null,
    type: "custom",
    custom: (data: DataEntityType) => <ColumnWithCopyToClipboard data={data.idUnique} title="fe fe-edit eventIcom"></ColumnWithCopyToClipboard>,
    key: 1,
    withFilter: null,
    class: "eventColumn",
  },

  {
    title: "Наименование",
    listFields: {
      fieldName: "name",
      comparison: "containsIgnoreCase",
      listVal: [""],
    },
    key: 5,
    withFilter: "all",
  },

  {
    title: "Дата создания",
    listFields: {
      fieldName: "dateAdded",
      comparison: "containsStrong",
      listVal: [""],
    },
    type: "date-time",
    key: 100,
    withFilter: "onlySorted",
    class: "dateTtimeColumn",
  },

  {
    title: "Дата изменения",
    listFields: {
      fieldName: "dateUpdated",
      comparison: "containsStrong",
      listVal: [""],
    },
    type: "date-time",
    key: 101,
    withFilter: "onlySorted",
    class: "dateTtimeColumn",
  },
];
